import React from 'react';

const TipsPaidIcon = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
    aria-hidden="true"
  >
    <circle cx="20" cy="20" r="20" fill="#8E8E93" />
    <path
      d="M25 15L15 25M15 25H23M15 25V17"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TipsPaidIcon;
